import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mail-editor',
  templateUrl: './mail-editor.component.html',
  styleUrls: ['./mail-editor.component.css']
})
export class MailEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
